"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('../../../commons/httpClient'),
  httpClient = _require.httpClient;
var store = require('../../../../../../../config/store');
var helpers = require('../../../checkout/helpers');
var _require2 = require('../../../../../../../config/constants'),
  GOOGLE_PAY = _require2.GOOGLE_PAY,
  GOOGLE_PAY_CALLBACK_TRIGGERS = _require2.GOOGLE_PAY_CALLBACK_TRIGGERS;
var _require3 = require('../../initializeCheckout'),
  initializeCheckout = _require3.initializeCheckout;
var _require4 = require('../../../commons'),
  createTemporaryBasket = _require4.createTemporaryBasket;
var GooglePay = /*#__PURE__*/_createClass(function GooglePay(config, applicationInfo, adyenTranslations, isExpressPdp, initialAmount) {
  var _this = this;
  _classCallCheck(this, GooglePay);
  _defineProperty(this, "getShippingMethods", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(shippingAddress) {
      var requestBody;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            requestBody = {
              paymentMethodType: GOOGLE_PAY,
              isExpressPdp: _this.isExpressPdp
            };
            if (shippingAddress) {
              requestBody.address = {
                city: shippingAddress.locality,
                country: shippingAddress.country,
                countryCode: shippingAddress.countryCode,
                stateCode: shippingAddress.administrativeArea,
                postalCode: shippingAddress.postalCode
              };
            }
            return _context.abrupt("return", httpClient({
              method: 'POST',
              url: _this.shippingMethodsUrl,
              data: {
                data: JSON.stringify(requestBody)
              }
            }));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
  _defineProperty(this, "selectShippingMethod", /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref2) {
      var shipmentUUID, ID, requestBody;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            shipmentUUID = _ref2.shipmentUUID, ID = _ref2.ID;
            requestBody = {
              paymentMethodType: GOOGLE_PAY,
              shipmentUUID: shipmentUUID,
              methodID: ID,
              isExpressPdp: _this.isExpressPdp
            };
            return _context2.abrupt("return", httpClient({
              method: 'POST',
              url: _this.selectShippingMethodUrl,
              data: {
                data: JSON.stringify(requestBody)
              }
            }));
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }());
  _defineProperty(this, "onShippingAddressChange", /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(shippingAddress) {
      var _shippingMethodsData$;
      var shippingMethodsData, selectedShippingMethod, newCalculation;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _this.getShippingMethods(shippingAddress);
          case 2:
            shippingMethodsData = _context3.sent;
            if (!(shippingMethodsData !== null && shippingMethodsData !== void 0 && (_shippingMethodsData$ = shippingMethodsData.shippingMethods) !== null && _shippingMethodsData$ !== void 0 && _shippingMethodsData$.length)) {
              _context3.next = 10;
              break;
            }
            selectedShippingMethod = shippingMethodsData.shippingMethods[0];
            _context3.next = 7;
            return _this.selectShippingMethod(selectedShippingMethod);
          case 7:
            newCalculation = _context3.sent;
            if (!(newCalculation !== null && newCalculation !== void 0 && newCalculation.grandTotalAmount)) {
              _context3.next = 10;
              break;
            }
            return _context3.abrupt("return", {
              newShippingOptionParameters: GooglePay.getShippingOptionsParameters(selectedShippingMethod, shippingMethodsData),
              newTransactionInfo: GooglePay.getTransactionInfo(newCalculation, shippingMethodsData)
            });
          case 10:
            return _context3.abrupt("return", {
              error: {
                reason: 'SHIPPING_ADDRESS_UNSERVICEABLE',
                message: 'Cannot ship to the selected address',
                intent: 'SHIPPING_ADDRESS'
              }
            });
          case 11:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }());
  _defineProperty(this, "onShippingOptionChange", /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(shippingAddress, shippingOptionData) {
      var shippingMethodsData, shippingMethods, matchingShippingMethod, newCalculation;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _this.getShippingMethods(shippingAddress);
          case 2:
            shippingMethodsData = _context4.sent;
            shippingMethods = shippingMethodsData === null || shippingMethodsData === void 0 ? void 0 : shippingMethodsData.shippingMethods;
            matchingShippingMethod = shippingMethods.find(function (sm) {
              return sm.ID === shippingOptionData.id;
            });
            _context4.next = 7;
            return _this.selectShippingMethod(matchingShippingMethod);
          case 7:
            newCalculation = _context4.sent;
            if (!(newCalculation !== null && newCalculation !== void 0 && newCalculation.grandTotalAmount)) {
              _context4.next = 10;
              break;
            }
            return _context4.abrupt("return", {
              newTransactionInfo: GooglePay.getTransactionInfo(newCalculation, shippingMethodsData)
            });
          case 10:
            return _context4.abrupt("return", {
              error: {
                reason: 'SHIPPING_ADDRESS_UNSERVICEABLE',
                message: 'Cannot ship to the selected address',
                intent: 'SHIPPING_OPTION'
              }
            });
          case 11:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x4, _x5) {
      return _ref5.apply(this, arguments);
    };
  }());
  _defineProperty(this, "onAdditionalDetails", function (state) {
    _this.document.querySelector('#additionalDetailsHidden').value = JSON.stringify(_objectSpread(_objectSpread({}, state.data), {}, {
      paymentData: {}
    }));
    _this.document.querySelector('#showConfirmationForm').submit();
  });
  _defineProperty(this, "onAuthorized", /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(data, actions) {
      var authorizedEvent;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            authorizedEvent = data.authorizedEvent;
            try {
              _this.customer = GooglePay.formatCustomerObject(authorizedEvent);
              actions.resolve();
            } catch (error) {
              actions.reject();
            }
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x6, _x7) {
      return _ref6.apply(this, arguments);
    };
  }());
  _defineProperty(this, "callPaymentFromComponent", function (data) {
    return httpClient({
      url: _this.paymentFromComponentURL,
      method: 'POST',
      data: {
        data: JSON.stringify(data),
        paymentMethod: GOOGLE_PAY
      }
    });
  });
  _defineProperty(this, "onSubmit", /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(state, component, actions) {
      var _response$fullRespons, stateData, response;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            $.spinner().start();
            stateData = _objectSpread(_objectSpread({}, state.data), {}, {
              paymentType: 'express'
            });
            _context6.next = 5;
            return _this.callPaymentFromComponent(_objectSpread(_objectSpread({}, stateData), {}, {
              customer: _this.customer,
              isExpressPdp: _this.isExpressPdp
            }));
          case 5:
            response = _context6.sent;
            if (!(response !== null && response !== void 0 && response.resultCode)) {
              GooglePay.handleError(actions.reject);
            }
            helpers.createShowConfirmationForm(_this.showConfirmationAction);
            if (_this.isExpressPdp) {
              _this.helpers.setExpressRedirectUrl();
            }
            helpers.setOrderFormData(response);
            document.querySelector('#additionalDetailsHidden').value = JSON.stringify(_objectSpread(_objectSpread({}, stateData), response));
            actions.resolve({
              resultCode: response === null || response === void 0 ? void 0 : response.resultCode,
              action: response === null || response === void 0 ? void 0 : (_response$fullRespons = response.fullResponse) === null || _response$fullRespons === void 0 ? void 0 : _response$fullRespons.action
            });
            if ((response === null || response === void 0 ? void 0 : response.resultCode) === 'Authorised') {
              GooglePay.submitSuccessForm(response);
            }
            GooglePay.stopSpinner();
            _context6.next = 20;
            break;
          case 16:
            _context6.prev = 16;
            _context6.t0 = _context6["catch"](0);
            GooglePay.stopSpinner();
            GooglePay.handleError(actions.reject);
          case 20:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[0, 16]]);
    }));
    return function (_x8, _x9, _x0) {
      return _ref7.apply(this, arguments);
    };
  }());
  _defineProperty(this, "onPaymentDataChanged", /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(intermediatePaymentData) {
      var callbackTrigger, shippingAddress, shippingOptionData, paymentDataRequestUpdate;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            callbackTrigger = intermediatePaymentData.callbackTrigger, shippingAddress = intermediatePaymentData.shippingAddress, shippingOptionData = intermediatePaymentData.shippingOptionData;
            paymentDataRequestUpdate = {};
            if (!(callbackTrigger === GOOGLE_PAY_CALLBACK_TRIGGERS.INITIALIZE)) {
              _context7.next = 9;
              break;
            }
            if (!_this.isExpressPdp) {
              _context7.next = 6;
              break;
            }
            _context7.next = 6;
            return createTemporaryBasket();
          case 6:
            _context7.next = 8;
            return _this.onShippingAddressChange(shippingAddress);
          case 8:
            paymentDataRequestUpdate = _context7.sent;
          case 9:
            if (!(callbackTrigger === GOOGLE_PAY_CALLBACK_TRIGGERS.SHIPPING_ADDRESS)) {
              _context7.next = 13;
              break;
            }
            _context7.next = 12;
            return _this.onShippingAddressChange(shippingAddress);
          case 12:
            paymentDataRequestUpdate = _context7.sent;
          case 13:
            if (!(callbackTrigger === GOOGLE_PAY_CALLBACK_TRIGGERS.SHIPPING_OPTION)) {
              _context7.next = 17;
              break;
            }
            _context7.next = 16;
            return _this.onShippingOptionChange(shippingAddress, shippingOptionData);
          case 16:
            paymentDataRequestUpdate = _context7.sent;
          case 17:
            return _context7.abrupt("return", new Promise(function (resolve) {
              resolve(paymentDataRequestUpdate);
            }));
          case 18:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x1) {
      return _ref8.apply(this, arguments);
    };
  }());
  _defineProperty(this, "getConfig", function () {
    return {
      showPayButton: _this.showPayButton,
      isExpress: _this.isExpress,
      buttonType: 'buy',
      emailRequired: true,
      shippingAddressRequired: true,
      shippingOptionRequired: true,
      shippingAddressParameters: {
        phoneNumberRequired: true
      },
      billingAddressRequired: true,
      billingAddressParameters: {
        format: 'FULL',
        phoneNumberRequired: true
      },
      gatewayMerchantId: window.merchantAccount,
      configuration: _this.config,
      callbackIntents: ['SHIPPING_ADDRESS', 'SHIPPING_OPTION'],
      amount: _this.amount,
      onAdditionalDetails: _this.onAdditionalDetails,
      onAuthorized: _this.onAuthorized,
      onSubmit: _this.onSubmit,
      paymentDataCallbacks: {
        onPaymentDataChanged: _this.onPaymentDataChanged
      }
    };
  });
  _defineProperty(this, "getComponent", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    var checkout, googlePayConfig;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return initializeCheckout(_this.applicationInfo, _this.translations);
        case 2:
          checkout = _context8.sent;
          googlePayConfig = _this.getConfig();
          return _context8.abrupt("return", window.AdyenWeb.createComponent(GOOGLE_PAY, checkout, googlePayConfig));
        case 5:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  })));
  var _window = window,
    basketAmount = _window.basketAmount,
    showConfirmationAction = _window.showConfirmationAction,
    shippingMethodsUrl = _window.shippingMethodsUrl,
    selectShippingMethodUrl = _window.selectShippingMethodUrl,
    paymentFromComponentURL = _window.paymentFromComponentURL;
  this.store = store;
  this.helpers = helpers;
  this.amount = initialAmount || JSON.parse(basketAmount);
  this.showPayButton = true;
  this.isExpress = true;
  this.isExpressPdp = isExpressPdp;
  this.paymentFromComponentURL = paymentFromComponentURL;
  this.showConfirmationAction = showConfirmationAction;
  this.shippingMethodsUrl = shippingMethodsUrl;
  this.selectShippingMethodUrl = selectShippingMethodUrl;
  this.applicationInfo = applicationInfo;
  this.translations = adyenTranslations;
  this.config = config;
  this.document = document;
});
_defineProperty(GooglePay, "formatCustomerObject", function (customerData) {
  var shippingData = customerData.shippingAddress;
  var billingData = customerData.paymentMethodData.info.billingAddress;
  var nameParts = customerData.shippingAddress.name.split(' ');
  var firstName = nameParts[0];
  var lastName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : ''; // Join the rest
  return {
    addressBook: {
      addresses: {},
      preferredAddress: {
        address1: shippingData.address1,
        address2: shippingData.address2 ? shippingData.address2 : null,
        city: shippingData.locality,
        countryCode: {
          displayValue: shippingData.countryCode,
          value: shippingData.countryCode
        },
        firstName: firstName,
        lastName: lastName,
        ID: customerData.email,
        postalCode: shippingData.postalCode,
        stateCode: shippingData.administrativeArea
      }
    },
    billingAddressDetails: {
      address1: billingData.address1,
      address2: billingData.address2 ? billingData.address2 : null,
      city: billingData.locality,
      countryCode: {
        displayValue: billingData.countryCode,
        value: billingData.countryCode
      },
      firstName: firstName,
      lastName: lastName,
      postalCode: billingData.postalCode,
      stateCode: billingData.administrativeArea
    },
    customer: {},
    profile: {
      firstName: firstName,
      lastName: lastName,
      email: customerData.email,
      phone: shippingData.phoneNumber
    }
  };
});
_defineProperty(GooglePay, "getTransactionInfo", function (newCalculation) {
  var _newCalculation$local, _newCalculation$grand, _newCalculation$grand2;
  return {
    countryCode: newCalculation === null || newCalculation === void 0 ? void 0 : (_newCalculation$local = newCalculation.locale) === null || _newCalculation$local === void 0 ? void 0 : _newCalculation$local.slice(-2),
    currencyCode: newCalculation === null || newCalculation === void 0 ? void 0 : (_newCalculation$grand = newCalculation.grandTotalAmount) === null || _newCalculation$grand === void 0 ? void 0 : _newCalculation$grand.currency,
    totalPriceStatus: 'FINAL',
    totalPriceLabel: 'Total',
    totalPrice: "".concat(newCalculation === null || newCalculation === void 0 ? void 0 : (_newCalculation$grand2 = newCalculation.grandTotalAmount) === null || _newCalculation$grand2 === void 0 ? void 0 : _newCalculation$grand2.value)
  };
});
_defineProperty(GooglePay, "getShippingOptionsParameters", function (selectedShippingMethod, shippingMethodsData) {
  return {
    defaultSelectedOptionId: selectedShippingMethod.ID,
    shippingOptions: shippingMethodsData.shippingMethods.map(function (sm) {
      return {
        label: sm.displayName,
        description: sm.description,
        id: sm.ID
      };
    })
  };
});
_defineProperty(GooglePay, "submitSuccessForm", function (response) {
  var _document$querySelect;
  if (document.querySelector('#result')) {
    var _response$fullRespons2, _response$fullRespons3, _response$fullRespons4, _response$fullRespons5, _response$fullRespons6, _response$fullRespons7, _response$fullRespons8;
    document.querySelector('#result').value = JSON.stringify({
      pspReference: (_response$fullRespons2 = response.fullResponse) === null || _response$fullRespons2 === void 0 ? void 0 : _response$fullRespons2.pspReference,
      resultCode: (_response$fullRespons3 = response.fullResponse) === null || _response$fullRespons3 === void 0 ? void 0 : _response$fullRespons3.resultCode,
      paymentMethod: (_response$fullRespons4 = response.fullResponse) !== null && _response$fullRespons4 !== void 0 && _response$fullRespons4.paymentMethod ? response.fullResponse.paymentMethod : (_response$fullRespons5 = response.fullResponse) === null || _response$fullRespons5 === void 0 ? void 0 : (_response$fullRespons6 = _response$fullRespons5.additionalData) === null || _response$fullRespons6 === void 0 ? void 0 : _response$fullRespons6.paymentMethod,
      donationToken: (_response$fullRespons7 = response.fullResponse) === null || _response$fullRespons7 === void 0 ? void 0 : _response$fullRespons7.donationToken,
      amount: (_response$fullRespons8 = response.fullResponse) === null || _response$fullRespons8 === void 0 ? void 0 : _response$fullRespons8.amount
    });
  }
  (_document$querySelect = document.querySelector('#showConfirmationForm')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.submit();
});
_defineProperty(GooglePay, "handleError", function (reject) {
  var _document$querySelect2;
  reject();
  if (document.querySelector('#result')) {
    document.querySelector('#result').value = JSON.stringify({
      error: true
    });
  }
  (_document$querySelect2 = document.querySelector('#showConfirmationForm')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.submit();
});
_defineProperty(GooglePay, "stopSpinner", function () {
  var _$;
  if ((_$ = $) !== null && _$ !== void 0 && _$.spinner) {
    var spinnerFn = $.spinner();
    if (spinnerFn.stop) {
      var _$$spinner;
      (_$$spinner = $.spinner()) === null || _$$spinner === void 0 ? void 0 : _$$spinner.stop();
    }
  }
});
module.exports = GooglePay;